import React from 'react';

import { Spinner } from '@components/index';
import { LOCAL_STORAGE_KEYS } from '@constants/storage';
import { useGetLeadCustomFieldsQuery } from '@features/lead-management/queries/LeadManagementQuery';
import { getLocalStorageItem } from '@utils/storage';

import EmptyTabState from './EmptyTabState';
import FormResponseFieldRow from './FormResponseFieldRow';
import TabError from './TabError';

import { FormResponseTabProps } from '../../types/leadActivity';

const FormResponseTab: React.FC<FormResponseTabProps> = ({ leadId }) => {
  const organizationId =
    getLocalStorageItem(LOCAL_STORAGE_KEYS.ORGANIZATION_ID) || '';

  const { data, isFetching, isError, refetch } = useGetLeadCustomFieldsQuery(
    { organizationId, leadId },
    { skip: !organizationId || !leadId }
  );

  const customFields = data ?? [];

  const renderContent = () => {
    if (isFetching)
      return (
        <div className="flex justify-center py-25">
          <Spinner size="sm" />
        </div>
      );

    if (isError)
      return (
        <TabError
          handleRefetch={refetch}
          message="Failed to load form fields"
        />
      );

    if (!customFields.length)
      return (
        <EmptyTabState
          title="No form fields"
          subtitle="This lead's Meta form had no additional fields to capture."
        />
      );

    return (
      <dl className="flex flex-col">
        {customFields.map((field, index) => (
          <FormResponseFieldRow
            key={field.key}
            field={field}
            isLast={index === customFields.length - 1}
          />
        ))}
      </dl>
    );
  };

  return <div className="p-6">{renderContent()}</div>;
};

export default FormResponseTab;
